module.exports = __webpack_public_path__ + "img/blog.14904f66.jpg";